var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-wrapper"},[_c('div',{staticClass:"test-form-box"},[_c('SyForm',{attrs:{"config":_vm.config},on:{"getData":_vm.getData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }